import React, { useState, useEffect } from "react";
import { theme, ConfigProvider, Tabs, Card, Spin } from "antd";
import menuItems from "../../../config/data/menus.json";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
// import styles from "../../../assets/styles/styles";
import { labelConfig, staticConfig } from "../treasury.config";
import MaturitySettings from "./components/Maturity";
import PricingAndRate from "./components/PricingAndRating";
import { InstrumentParameters } from "./components/InstrumentParameters";
import ProductInformation from "./components/ProductInformation";
import Preview from "./components/Preview";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import TabLabel from "./components/TabLabel";
import dayjs from "dayjs";
import {
  useGetProdTemplate,
  useGetTreasuryItem,
} from "./hooks/useServerActions";
import { connect } from "react-redux";
import Accounting from "./components/Accounting";
import TaxAndCharges from "./components/TaxAndChargesForm";

const EditTreasuryBill = (props) => {
  const navigate = useNavigate();
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("/cst0100");
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#FBE8FF");
  const [searchColorBgContainer, setSearchColorBgContainer] =
    useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(100);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#2F172D");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  function onMenuSelect(menuItems) {
    // console.log(menuItems.key);
    setSelectedKey(menuItems.key);
    navigate(menuItems.key, { replace: false });
  }

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(100);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider
      theme={{
        token: {},
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
          },
          Form: {},
          Button: {
            colorBgBase: "#BA24D5",
            colorBorder: "#D0D5DD",
            defaultHoverBorderColor: "#BA24D5",
            defaultHoverColor: "#BA24D5",
          },
        },
      }}
    >
      <MainLayout
        collapsed={collapsed}
        searchColorBgContainer={searchColorBgContainer}
        theme={menuTheme}
        defaultSelectedKeys={selectedKey}
        items={menuItems}
        onClick={onMenuSelect}
        switchLabel={switchLabel}
        onSwitchClick={onSwitchClick}
        switchLabelColor={switchLabelColor}
        logoDimensions={logoDimensions}
        menuSearchBarState={menuSearchBarState}
        menuSearchIconState={menuSearchIconState}
        switchLabelState={switchLabelState}
        setCollapsed={setCollapsed}
        leftLayoutMargin={leftLayoutMargin}
        colorBgContainer={colorBgContainer}
        pageItems={staticConfig.updateTreasuryBillBreadcrumbItems}
      >
        <TopContent
          pageTitle={labelConfig.treasuryBill}
          createPageTitle={"Update product..."}
          // pageItems={staticConfig.createTreasuryBillBreadcrumbItems}
        />
        <MainPage session={session} titleOfPage={"Add Customer"} />
      </MainLayout>
    </ConfigProvider>
  );
};

function MainPage(props) {
  const session = props.session;
  const { state: treasuryData } = useLocation();

  const [activePage, setActivePage] = React.useState(1);
  const [data, setData] = React.useState();
  const [hasModifed, setHasModified] = React.useState([]);
  const { loading, prodTemplate } = useGetProdTemplate(session);
  const { loading: treasuryLoading, treasuryBillItem } = useGetTreasuryItem(
    session,
    treasuryData?.key
  );
  // React.useEffect(() => {
  //   setData({
  //     ...treasuryData[0],
  //     startDate: dayjs(treasuryData[0].startDate),
  //     endDate: dayjs(treasuryData[0].endDate),
  //   });
  // }, [treasuryData]);

  useEffect(() => {
    treasuryBillItem &&
      setData({
        ...treasuryBillItem,
        restrictedOffice: treasuryBillItem?.restrictedOffice.map(
          (item) => item.id
        ),
        startDate: dayjs(treasuryBillItem?.startDate),
        endDate: dayjs(treasuryBillItem?.endDate),
        rolloverOption: treasuryBillItem?.autoRollover,
        settlementDate: treasuryBillItem?.settlementDateType?.value,
        productType: treasuryBillItem?.productType?.value,
        custodian: treasuryBillItem?.custodian?.id,
        accountingClassification:
          treasuryBillItem?.accountingClassification?.id,
        productCategory: treasuryBillItem?.productCategory?.value,
        instrumentType: treasuryBillItem?.instrumentType?.id,
        treasuryBillInterestType: treasuryBillItem?.interestType?.value,
        maturityProceed: treasuryBillItem?.maturityProceed?.value,
        allowTax: treasuryBillItem?.allowTax,
        taxGroup: treasuryBillItem?.taxGroup?.id,
        setupCharges: treasuryBillItem?.setupCharges,
        setupCharge: treasuryBillItem?.setupCharge?.id,
        redemptionCharges: treasuryBillItem?.redemptionCharges,
        redemptionCharge: treasuryBillItem?.redemptionCharge?.id,
        transferCharges: treasuryBillItem?.transferCharges,
        transferCharge: treasuryBillItem?.transferCharge?.id,
        allowBrokerage: treasuryBillItem?.allowBrokerage,
        commission: treasuryBillItem?.commission?.id,
        // treasuryBillInterestType:
        //   treasuryBillItem?.treasuryBillInterestType?.value,
        currency: treasuryBillItem?.currencyCode,
        issuer: treasuryBillItem?.issuer?.id,
        minInvestment: String(treasuryBillItem?.minInvestment),
        maxInvestment: String(treasuryBillItem?.maxInvestment),
        incrInvestment: String(treasuryBillItem?.incrInvestment),
        securityType: treasuryBillItem?.securityType?.value,
        tenor: treasuryBillItem?.tenor?.value,
        redemptionMode: treasuryBillItem?.redemptionMode?.value,
        pricingFrequency: treasuryBillItem?.pricingFrequency?.value,
        pricingMethod: treasuryBillItem?.pricingMethod?.value,
        interestRateSource: treasuryBillItem?.interestRateSource?.id,
        interestCalculationBasis:
          treasuryBillItem?.interestCalculationBasis?.value,
        accrualMethod: treasuryBillItem?.accrualMethod?.value,
        debitSourceAccountType: treasuryBillItem?.debitSourceAccountType?.value,
        investmentDealBookingDebit:
          treasuryBillItem?.investmentGL?.debitAccount?.id,
        investmentDealBookingCredit:
          treasuryBillItem?.investmentGL?.creditAccount?.id,
        interestAccrualDebit:
          treasuryBillItem?.accruedInterestGL?.debitAccount?.id,
        interestAccrualCredit:
          treasuryBillItem?.accruedInterestGL?.creditAccount?.id,
        investmentRedemptionDebit:
          treasuryBillItem?.settlementGL?.debitAccount?.id,
        investmentRedemptionCredit:
          treasuryBillItem?.settlementGL?.creditAccount?.id,
        incomeInterestDebit:
          treasuryBillItem?.interestIncomeGL?.debitAccount?.id,
        incomeInterestCredit:
          treasuryBillItem?.interestIncomeGL?.creditAccount?.id,
        incomeFeesDebit: treasuryBillItem?.principalGL?.debitAccount?.id,
        incomeFeesCredit: treasuryBillItem?.principalGL?.creditAccount?.id,
        incomePenaltyDebit: treasuryBillItem?.penaltyGL?.debitAccount?.id,
        incomePenaltyCredit: treasuryBillItem?.penaltyGL?.creditAccount?.id,
      });
  }, [treasuryBillItem]);

  const tabItems = [
    {
      key: "1",
      label: (
        <TabLabel
          modifiedPages={hasModifed}
          number={1}
          label="Product Information"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <ProductInformation
          data={data}
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          hasModifed={hasModifed}
          setHasModified={setHasModified}
          template={prodTemplate}
          // setIsValid={setIsValid}
        />
      ),
    },
    {
      key: "2",
      label: (
        <TabLabel
          modifiedPages={hasModifed}
          number={2}
          label="Instrument Parameter"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <InstrumentParameters
          setData={setData}
          data={data}
          setActivePage={setActivePage}
          activePage={activePage}
          hasModifed={hasModifed}
          setHasModified={setHasModified}
          template={prodTemplate}
        />
      ),
    },
    {
      key: "3",
      label: (
        <TabLabel
          modifiedPages={hasModifed}
          number={3}
          label="Price & Rate Settings"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <PricingAndRate
          setData={setData}
          data={data}
          setActivePage={setActivePage}
          activePage={activePage}
          hasModifed={hasModifed}
          setHasModified={setHasModified}
          template={prodTemplate}
        />
      ),
    },
    {
      key: "4",
      label: (
        <TabLabel
          modifiedPages={hasModifed}
          number={4}
          label="Maturity Settings"
          activeTab={activePage}
          setActivePage={setActivePage}
        />
      ),
      children: (
        <MaturitySettings
          setData={setData}
          data={data}
          setActivePage={setActivePage}
          activePage={activePage}
          hasModifed={hasModifed}
          setHasModified={setHasModified}
          template={prodTemplate}
        />
      ),
    },
    {
      key: "5",
      label: (
        <TabLabel
          number={5}
          label="Tax & Charges"
          activeTab={activePage}
          setActivePage={setActivePage}
          data={data}
          // form={form}
        />
      ),
      children: (
        <TaxAndCharges
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
          data={data}
          hasModifed={hasModifed}
          setHasModified={setHasModified}
          // form={form}
        />
      ),
    },
    {
      key: "6",
      label: (
        <TabLabel
          modifiedPages={hasModifed}
          number={6}
          label="Accounting"
          activeTab={activePage}
          setActivePage={setActivePage}
          data={data}
        />
      ),
      children: (
        <Accounting
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          template={prodTemplate}
          data={data}
          hasModifed={hasModifed}
          setHasModified={setHasModified}
        />
      ),
    },
    {
      key: "7",
      label: (
        <TabLabel
          modifiedPages={hasModifed}
          number={7}
          label="Preview"
          isLast
          activeTab={activePage}
        />
      ),
      children: (
        <Preview
          id={treasuryData?.key}
          setData={setData}
          setActivePage={setActivePage}
          activePage={activePage}
          data={data}
          template={prodTemplate}
        />
      ),
    },
  ];

  return (
    // <div style={{ width: 900, placeSelf: "center", marginTop: 20 }}>
    <div style={{ maxWidth: "75vw", marginInline: 30, marginTop: 20 }}>
      <Spin spinning={loading || treasuryLoading} size="large">
        <Tabs
          activeKey={String(activePage)}
          items={tabItems}
          tabPosition="left"
          tabBarGutter={0}
          style={{
            minHeight: "723px",
            border: "none",
            marginTop: 20,
          }}
          tabBarStyle={{
            width: "350px",
            borderRight: "none",

            // position: "sticky",
            // top: 30,
          }}
          // NOTE : STYLES ARE UNDER CREATE INTERBANK PLACEMENT
          className="custom-vertical-numbered-tabs"
        />
      </Spin>
    </div>
  );
}

export function SectionCard({ children }) {
  return (
    <Card style={{ padding: 0, borderRadius: 20, maxWidth: 560 }}>
      {children}
    </Card>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditTreasuryBill);
